module.exports = __webpack_public_path__ + "img/Til-ungdommen_Bilde-av-Sigurd-Hoel-og-Helge-Krogh.d18ac406.jpg";